import { TERMINAL, WEBSITE_TYPE } from '@shared/constants';

let GroupClass = null;
const getGroup = () => {
  try{
    if (!GroupClass) {
      GroupClass = require("@core/Group.js").default;
    }
    return GroupClass;
  }catch(e){
    return null;
  }
};

// 购物车商品平铺格式化
export const formatCartGoods = (_data = {}) => {
  try{
    const Group = getGroup();
    let flattedGoods = [];
    _data?.t?.vendors?.forEach(item => {
      item?.sorted?.forEach(goods => {
        goods.item._faId = item.id;
        goods.item._faName = item.name;
        goods.item._itemType = goods.itemType;
        let data = {
          id: item.id,
          name: item.name,
          itemType: goods.itemType,
          item: goods.item,
          invalid: item.invalid
        };
        let _group = new Group();
        _group.init(data);
        flattedGoods = flattedGoods.concat(_group?._mainSkus || []);
      })
    });
    return flattedGoods;
  }catch(err){
    console.log('catch formatCartGoods', err);
    return [];
  }
};

// 利用Object原型方法进行判断（Object的toString返回数据的具体类型）
export const instanceType = function (obj) {
  return Object.prototype.toString.call(obj).split('[object')[1].split(']')[0].replace(/\s+/g, '')?.toLocaleLowerCase();
}

// 动态样式
export function classnames() {
  const args = Array.from(arguments);
  if (args?.length <= 0) {
    return '';
  }
  let mixin, string = '', object = {};
  args.forEach(p => {
    if (typeof p === 'string') {
      string += `${p} `;
    }
    if (instanceType(p).toLocaleLowerCase() === 'object') {
      object = Object.assign({}, p)
    }
  });

  function handlerObject(obj = {}) {
    return Object.entries(obj).reduce((res, [key, val]) => {
      if (!!val) {
        res += `${key} `
      }
      return res;
    }, '');
  };
  mixin = string + handlerObject(object);
  return mixin;
}

// 环境判断
export function isProductionEnv() {
  let url = window.location.href.toLocaleLowerCase();
  if (url.indexOf('lenovouat.com') == -1) {
    return true;
  } else {
    return false;
  }
}
// 各个环境结算页链接处理
export function getCheckoutUrl(buyOther) {
  let _param = "";
  if (buyOther && buyOther == true) {
    _param = "buyOther=true";
  }
  const CHECKOUT_URL = {
    prod: {
      lenovo: {
        pc: 'https://buy.lenovo.com.cn/checkout/lenovopc.html?buytype=0&nc=1' + _param,
        wap: 'https://mbuy.lenovo.com.cn/checkout/lenovo.html?buytype=0&nc=1' + _param
      },
      epp: {
        pc: 'https://buy.lenovovip.com.cn/checkout/epppc.html?buytype=0&nc=1' + _param,
        wap: 'https://mbuy.lenovovip.com.cn/checkout/epp.html?buytype=0&nc=1' + _param
      },
      lecoo: {
        pc: 'https://buy.lecoo.com/checkout/lecoopc.html?buytype=0&nc=1' + _param,
        wap: 'https://mbuy.lecoo.com/checkout/lecoo.html?buytype=0&nc=1' + _param
      }
    },
    uat: {
      lenovo: {
        pc: 'https://buy.lenovouat.com/checkout/lenovopc.html?buytype=0&nc=1' + _param,
        wap: 'https://mbuy.lenovouat.com/checkout/lenovo.html?buytype=0&nc=1' + _param
      },
      epp: {
        pc: 'https://buy.vip.lenovouat.com/checkout/epppc.html?buytype=0&nc=1' + _param,
        wap: 'https://mbuy.vip.lenovouat.com/checkout/epp.html?buytype=0&nc=1' + _param
      },
      lecoo: {
        pc: 'https://buylecoo.lenovouat.com/checkout/lecoopc.html?buytype=0&nc=1' + _param,
        wap: 'https://mbuylecoo.lenovouat.com/checkout/lecoo.html?buytype=0&nc=1' + _param
      }
    },
  }
  const env = isProductionEnv() ? 'prod' : 'uat';
  let site = 'lenovo';
  if (window._shopId === WEBSITE_TYPE.lenovo) {
    site = 'lenovo'
  }
  if (window._shopId === WEBSITE_TYPE.lecoo) {
    site = 'lecoo'
  }
  if (window._shopId === WEBSITE_TYPE.epp) {
    site = 'epp'
  }
  const platform = window._terminal === TERMINAL.PC ? 'pc' : 'wap';
  return CHECKOUT_URL[env][site][platform];
}

// 用于生成随机id
export const guid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export function getTerminal() {
  let ua = navigator.userAgent.toLowerCase();
  //wap
  let is_mobi = ua.match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
  if (is_mobi) {
    //微信
    if (ua.indexOf('micromessenger') != -1) {
      return TERMINAL.WX;
    }
    //app
    if (ua.indexOf('lenovoofficialapp') != -1) {
      return TERMINAL.APP;
    }
    return TERMINAL.WAP;
  }
  //wap
  if (document.domain.indexOf("mbuy") != -1) {
    return TERMINAL.WAP;
  }

  //pc
  return TERMINAL.PC;
}